/**
 * A picture, shown whole on a dark ground.
 *
 * One body for both surfaces that show an image: the Documents preview dialog and the chat
 * lightbox (`features/project/components/attachment-preview-dialog.tsx`). The dark ground is
 * deliberately not a theme surface — a photo is read against a neutral dark whichever theme the
 * app is in, which is what every image viewer does and why the framing is the same in both
 * places. Each caller owns its own box; this draws the picture inside it.
 */

import { cn } from "@/lib/utils";

export function ImagePreviewBody({
  url,
  name,
  className,
  imageClassName,
}: {
  url: string;
  /** The picture's accessible name — the file's, since nothing else describes it. */
  name: string;
  className?: string;
  imageClassName?: string;
}) {
  return (
    <div className={cn("flex items-center justify-center bg-black/95", className)}>
      <img
        src={url}
        alt={name}
        className={cn("h-auto w-auto max-h-full max-w-full object-contain", imageClassName)}
      />
    </div>
  );
}
